import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import VueCollapse from "vue2-collapse";
import store from "./store";
import HomepageServices from "./blocks/HomepageServices";
import InlineSvg from "vue-inline-svg/dist/vue-inline-svg";
import ServicesWheel from "./components/ServicesWheel";
import ChallengesAndSolutionsWheel from "./components/ChallengesAndSolutionsWheel";
import TeamPage from "./components/TeamPage";
import OurWork from "./components/OurWork";
import SolutionsWheel from "./components/SolutionsWheel";
import OfficeLocationsMap from "./components/OfficeLocationsMap";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import ServiceFeatures from "./components/ServiceFeatures";
import ResourcesFilter from "./components/ResourcesFilter";
import ResourcesLoadMore from "./components/ResourcesLoadMore";
import VueSvgIconPolyFill from "@yzfe/vue-svgicon-polyfill";

Vue.config.productionTip = false;

Vue.component("GmapCluster", GmapCluster);

Vue.use(VueSvgIconPolyFill);
Vue.use(VueScrollTo);
Vue.use(VueCollapse);

Vue.component("inline-svg", InlineSvg);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA-8pIx133xsqhjVX9M6Q7l-AdnhD9I7Rc"
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

// Declare each block here
if (document.getElementById("homepage_services")) {
  new Vue({
    store,
    render: h => h(HomepageServices)
  }).$mount("#homepage_services");
}

if (document.getElementById("services_wheel")) {
  new Vue({
    store: store,
    render: h => h(ServicesWheel)
  }).$mount("#services_wheel");
}

if (document.getElementById("challenges_and_solutions_wheel")) {
  new Vue({
    store,
    render: h => h(ChallengesAndSolutionsWheel)
  }).$mount("#challenges_and_solutions_wheel");
}

if (document.getElementById("team_page")) {
  new Vue({
    store,
    render: h => h(TeamPage)
  }).$mount("#team_page");
}

if (document.getElementById("our_work")) {
  new Vue({
    store,
    render: h => h(OurWork)
  }).$mount("#our_work");
}

if (document.getElementById("solutions_wheel")) {
  new Vue({
    store,
    render: h => h(SolutionsWheel)
  }).$mount("#solutions_wheel");
}

if (document.getElementById("office_locations_map")) {
  new Vue({
    store,
    render: h => h(OfficeLocationsMap)
  }).$mount("#office_locations_map");
}

if (document.getElementById("service_features")) {
  new Vue({
    store,
    render: h => h(ServiceFeatures)
  }).$mount("#service_features");
}

if (document.getElementById("resources-filter")) {
  new Vue({
    store,
    render: h => h(ResourcesFilter)
  }).$mount("#resources-filter");
}

if (document.getElementById("resources-load-more")) {
  new Vue({
    store,
    render: h => h(ResourcesLoadMore)
  }).$mount("#resources-load-more");
}
